import { logProgramChange } from '@shoflo/studio-redux/utils/sendToDatadogWithIds';

import setProgram from './setProgram';
import sceneLayouts from 'constants/SceneLayouts';
import { getProgramLayers } from 'utils/broadcastSourceHelper';
import setSceneLayout from 'actions/Broadcast/program/setSceneLayout';

/**
 * @param {Object} attendeeIds a map of attendeIds. { someAttendeeId: 'someAttendeeId' }
 */
export default attendeeIds => {
  return (dispatch, getState) => {
    const { program, attendeeCameraStatus } = getState();
    const { _id: programLayoutId } = program;
    const layout = sceneLayouts.find(l => l.id === programLayoutId);

    const layers = getProgramLayers(program);
    // Check if source exists in program layer
    const layerSource = layers.filter(layer => attendeeIds[layer.source.value]);

    // If source is in program we update the program scene
    if (layerSource.length) {
      const scene = {
        ...program,
        layers: layers.map(ls => {
          const isCameraOn = attendeeCameraStatus[ls.source.value];
          if (typeof isCameraOn === 'boolean' && ls.layer) {
            ls.layer.isCameraOn = isCameraOn;
          }
          return ls;
        })
      };

      /*
        if its a scene action i.e, when a scene is taken live,
        the layout is not valid, we dont want to set this.
      */
      if (layout) {
        dispatch(setSceneLayout(layout));
      }
      // Dispatch action to setProgram
      dispatch(setProgram(scene, true, { emitSocket: false }));
      logProgramChange(getState, 'updateProgramByCameraSource action');
    }
  };
};
